export default __webpack_public_path__ + "static/media/kitware.13713d64.svg";